module.exports = __webpack_public_path__ + "static/media/FacebookScoreShareIcon.d2db337a.svg";